var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewactivity = function SvgViewactivity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10.435,
    viewBox: "0 0 12 10.435",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_viewactivity",
    d: "M120.98-790.706v-.94h-1.926a.947.947,0,0,1-.695-.288.947.947,0,0,1-.288-.695v-5.2h-2.127v.94a.767.767,0,0,1-.231.563.767.767,0,0,1-.563.231h-1.893a.766.766,0,0,1-.563-.232.769.769,0,0,1-.231-.564v-2.665a.759.759,0,0,1,.231-.561.771.771,0,0,1,.563-.229h1.893a.767.767,0,0,1,.563.231.767.767,0,0,1,.231.563v.94h5.036v-.943a.761.761,0,0,1,.231-.563.771.771,0,0,1,.563-.229h1.893a.766.766,0,0,1,.563.232.768.768,0,0,1,.231.564v2.665a.759.759,0,0,1-.231.561.771.771,0,0,1-.563.229h-1.893a.767.767,0,0,1-.563-.231.767.767,0,0,1-.231-.563v-.94h-2.127v5.2a.2.2,0,0,0,.056.144.2.2,0,0,0,.144.056h1.926v-.943a.761.761,0,0,1,.231-.563.771.771,0,0,1,.563-.229h1.893a.766.766,0,0,1,.563.232.769.769,0,0,1,.231.564v2.665a.759.759,0,0,1-.231.561.771.771,0,0,1-.563.229h-1.893a.767.767,0,0,1-.563-.231A.767.767,0,0,1,120.98-790.706Zm-7.736-8.858v0Zm8.518,6.183v0Zm0-6.183v0Zm0,2.688h1.918v-2.688h-1.918Zm0,6.183h1.918v-2.687h-1.918Zm-8.518-6.183h1.918v-2.688h-1.918Z",
    transform: "translate(-112.462 800.346)",
    fill: "#3b3b3b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewactivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewactivity.ef889383.svg";
export { ForwardRef as ReactComponent };